import {createAction} from '@reduxjs/toolkit'

export const addToCalendarClicked = createAction('ADD_TO_CALENDAR_CLICKED')

export const addToCalendarOptionClicked = createAction<AddToCalendarOptionClickedParams>(
  'ADD_TO_CALENDAR_OPTION_CLICKED',
)

export interface AddToCalendarOptionClickedParams {
  origin: string
  sourcePage: string
}
